import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody, CardHeader } from 'reactstrap'
import { getJobScreenings } from 'store/Recruitment/actions'

function Questions() {
  const dispatch = useDispatch()
  const { jobProps, jobScreenings } = useSelector((store) => store.recruitment)

  const gender = jobProps?.find((el) => el?.name === 'gender')
  const date_of_birth = jobProps?.find((el) => el?.name === 'date_of_birth')
  const country = jobProps?.find((el) => el?.name === 'country')
  const profile_image = jobProps?.find((el) => el?.name === 'profile_image')
  const resume = jobProps?.find((el) => el?.name === 'resume')
  const cover_letter = jobProps?.find((el) => el?.name === 'cover_letter')
  const terms_and_conditions = jobProps?.find(
    (el) => el?.name === 'terms_and_conditions'
  )
  const customQuestionsIds = jobProps?.find(
    (el) => el?.name === 'custom_questions'
  )

  const [customQuestions, setCustomQuestions] = useState([])

  useEffect(() => {
    dispatch(getJobScreenings())
  }, [dispatch])

  useEffect(() => {
    setCustomQuestions(
      jobScreenings?.filter((el) => customQuestionsIds?.value?.includes(el?.id))
    )
  }, [customQuestionsIds, jobScreenings])

  return (
    <div
      className='d-flex align-items-start justify-content-between'
      style={{ gap: '2rem' }}
    >
      <Card className='w-50'>
        <CardHeader className='title'>Job Questions</CardHeader>
        <CardBody className='d-flex justify-content-between'>
          <div className='w-50'>
            <p className='title'>Need to ask ?</p>
            <ul className='ml-4 mt-2'>
              {gender?.value ? <li>Gender</li> : null}
              {date_of_birth?.value ? <li>Date Of Birth</li> : null}
              {country?.value ? <li>Country</li> : null}
            </ul>
          </div>
          <div className='w-50'>
            <p className='title'>Need to show option ?</p>
            <ul className='ml-4 mt-2'>
              {profile_image?.value ? <li>Profile Image</li> : null}
              {resume?.value ? <li>Resume</li> : null}
              {cover_letter?.value ? <li>Cover Letter</li> : null}
              {terms_and_conditions?.value ? (
                <li>Terms And Conditions</li>
              ) : null}
            </ul>
          </div>
        </CardBody>
      </Card>
      <Card className='w-50'>
        <CardHeader className='title'>Custom Questions</CardHeader>
        <CardBody className='d-flex justify-content-between'>
          <div className='w-50'>
            <ul className='ml-4'>
              {customQuestions?.map((question) => (
                <li key={question?.id}>{question?.question}</li>
              ))}
            </ul>
          </div>
        </CardBody>
      </Card>
    </div>
  )
}

function Field({ label, value }) {
  return (
    <>
      <p className='my-1'>
        <span style={{ color: 'black', fontWeight: '500' }}>{label}:</span>{' '}
        {value}
      </p>
    </>
  )
}

export default Questions
